export const MEDIA_BUTTON_ACTIONS = {
    pause: 'pause',
    play: 'play',
    replay: 'replay',
};

export default MEDIA_BUTTON_ACTIONS;
